export const navItems = [
  { id: 1, label: 'Новости', href: '/#news' },
  { id: 2, label: 'О нас', href: '/#about' },
  { id: 4, label: 'Галерея', href: '/gallery' },        // новая кнопка
  { id: 5, label: 'Документы', href: '/documents' },
  { id: 6, label: 'Мероприятия', href: '/events' },
  { id: 7, label: 'Контакты', href: '/#contacts' },
  { id: 8, label: 'Вступить в партию', href: '/howtojoin' }
];